import { NetworkStatus } from '@/assets/icons';

export const OfflineStatus: React.FC = () =>
    <NetworkStatus color="#b02000" />
